export default __webpack_public_path__ + "core/assets/posters/flag-loop.jpg";